import React, {Component} from 'react';

import {connect} from 'react-redux';
import {Redirect, Route, Switch, withRouter} from "react-router";

import {animateScroll as scroll} from 'react-scroll'
import qs from "query-string";
import cx from 'classnames'
import VendorModal from 'react-modal';
import Sticky from 'react-stickynode';
import Responsive from "./components/utilites/Responsive";

import {setInfoNoticeWasShown, updateParams} from "./redux/actions/index"
import {getAttrsDefaultOptions, getAttrLink, getFlattenAttrs} from "./helpers/attributes";
import analytics from "./helpers/analytics";

import config from './config'

// Common Styles
import './scss/normalize.scss'
import './scss/fonts.scss'

// Components
import Breadcrumbs from './components/Breadcrumbs'
import PhoneNumber from './components/PhoneNumber';
import AdditionalContent from "./components/AdditionalContent";
import Loader from "./components/Loader";
import ConfigEmailModal from "./components/ConfigEmailModal";
import PreviewImage from "./components/PreviewImage";
import AttributePanel from "./components/AttributePanel";
import Summary from "./components/Summary";
import Navigation from "./components/NavigationGeneral";
import TotalInfo from "./components/TotalInfo"
import Spinner from "./components/Spinner";

// Assets
import {ReactComponent as ArrowDownIcon} from './assets/img/arrow-down-icon.svg';
import {ReactComponent as DownloadIcon} from './assets/img/download-icon.svg';
import {ReactComponent as ToTopIcon} from './assets/img/to-top.svg';
import {ReactComponent as Logo} from './assets/img/logo.svg';

// App component styles
import './App.scss'
import styles from './App.module.scss';

VendorModal.setAppElement('#root');

class App extends Component {

  constructor(props) {

    super(props);

    this.footerRef = React.createRef();

    this.state = {
      configEmailModalOpen: false,
      stickyNavigation: false
    };

  }

  setAppParams() {

    const {attributes} = this.props;

    let urlParams = qs.parse(window.location.search),
      defaultAttrsParams = getAttrsDefaultOptions(attributes),
      isClearSession = false;

    const allowedParams = [
      ...Object.keys(defaultAttrsParams),
      'edit-key'
    ];

    // Default values
    defaultAttrsParams.tops = 'massiv-gerade-kante-40mm';
    defaultAttrsParams.frames = 'mikado-schwarz';
    defaultAttrsParams.sizes = '220-x-100';
    defaultAttrsParams.color = 'pure';

    for (let key in urlParams) {
      if (allowedParams.indexOf(key) === -1) {
        delete urlParams[key];
      } else {
        isClearSession = true;
      }
    }

    let params;

    // Configurator params from url or session storage
    if (isClearSession) {

      params = {
        ...defaultAttrsParams,
        ...urlParams
      };

      // Analytics
      analytics.onInit();

    } else {

      params = {
        ...defaultAttrsParams,
        ...this.props.params,
      };

      // Don't show info notice if it's not first load
      this.props.setInfoNoticeWasShown();

    }

    this.props.updateParams(params, true);

  }

  componentWillMount() {
    this.setAppParams();
  }

  componentDidMount() {

    window.addEventListener('scroll', this.onScroll);
    window.addEventListener("orientationchange", this.onOrientationChange);

    setTimeout(() => {
      this.setNavigationSticky();
    }, 0);

    // Analytics
    this.historyChangeUnSubscribe = this.props.history.listen((e, type) => {

      const {pathname, state} = e,
        prevPath = state !== undefined ? state.prev : '';

      let {attributes, params} = this.props;
      analytics.onHistoryChange(pathname, prevPath, type, attributes, params);

    });

  }

  componentWillUnmount() {

    window.removeEventListener('scroll', this.onScroll);
    window.removeEventListener("orientationchange", this.onOrientationChange);

    this.historyChangeUnSubscribe();

  }

  onScroll = () => {
    this.setNavigationSticky();
  };

  onOrientationChange = () => {
    setTimeout(() => {
      this.setNavigationSticky();
    }, 0);
  };

  setNavigationSticky = () => {

    if (!this.footerRef.current) {
      return;
    }

    let isSticky = this.footerRef.current.getBoundingClientRect().y - window.innerHeight >= 0;

    if (this.state.stickyNavigation !== isSticky) {
      this.setState({
        stickyNavigation: isSticky
      });
    }

  };

  toggleConfigEmailModal = () => {
    this.setState({
      configEmailModalOpen: !this.state.configEmailModalOpen
    });
  };

  scrollToFooter = () => {
    scroll.scrollTo(this.footerRef.current.offsetTop, {
      duration: 800
    })
  };

  scrollToTop = () => {
    scroll.scrollToTop({
      duration: 800
    });
  };

  render() {

    const {params, previewLoading, productData} = this.props;

    if (params === undefined || productData === false) {
      return <Loader fw/>;
    }

    return (

      <React.Fragment>

        <div className="header">
          <a href="/">
            <Logo className="logo header__logo"/>
          </a>
          <PhoneNumber className="header__phone-number"/>
        </div>

        <div className="main">
          <div className="preview">
            <div className="preview__main">

              {previewLoading &&
              <Spinner className={'preview__loader'}/>
              }

              <PreviewImage className="preview__image"/>
              <div className="preview__actions">
                <div className="action-button action-button--scroll-down" onClick={this.scrollToFooter}>
                  <div className="action-button__text">Scroll nach unten für mehr Infos</div>
                  <ArrowDownIcon className="action-button__icon"/>
                </div>
                <div className="action-button" onClick={this.toggleConfigEmailModal}>
                  <div className="action-button__text">Tisch speichern</div>
                  <DownloadIcon className="action-button__icon"/>
                </div>
              </div>
            </div>
          </div>

          <div className="sidebar">

            <div className="sidebar__main">

              <PhoneNumber className="sidebar__phone-number"/>

              <Route
                path={`/${config.attrBase}/:attrSlug`}
                render={(props) => <Breadcrumbs className="sidebar__breadcrumbs" {...props}/>}
              />

              <Switch>
                <Route
                  path={`/${config.attrBase}/:attrSlug`}
                  render={(props) => <AttributePanel className="sidebar__variations" {...props}/>}
                />
                <Route path='/summary' component={Summary}/>
                <Redirect to={getAttrLink(this.props.attributes[0].slug)}/>
              </Switch>

              <Route
                path={`/${config.attrBase}/:attrSlug`}
                render={(props) => (
                  <>
                    <TotalInfo className="sidebar__total-info" {...props}/>
                    <div className="sidebar__delivery-note">inkl. Versand und Aufbau</div>
                  </>
                )}
              />

            </div>

            <div className="sidebar__footer" style={{height: '62px'}}>
              <Responsive match={Responsive.matches.mobile}>
                {(match) =>
                  <Navigation
                    className={cx({
                      'navigation-sticky': this.state.stickyNavigation && match
                    })}
                  />}
              </Responsive>
            </div>

          </div>

        </div>

        <Sticky top={0} innerZ={9999}>
          {status => (
            status.status !== Sticky.STATUS_ORIGINAL &&
            <div className={styles['sticky-up']}>

              <div className={styles['sticky-up__preview']}>
                <PreviewImage/>
              </div>

              <div className={styles['sticky-up__control']}>
                <button onClick={this.scrollToTop} className={styles['sticky-up__btn']}>
                  Weiter konfigurieren
                </button>
                <ToTopIcon className={styles['sticky-up__icon']}/>
              </div>
            </div>
          )}
        </Sticky>

        <div className="footer" ref={this.footerRef}>
          <AdditionalContent/>
        </div>

        <ConfigEmailModal
          open={this.state.configEmailModalOpen}
          onClose={this.toggleConfigEmailModal}
        />

      </React.Fragment>

    );
  }
}

export default withRouter(connect(
  state => ({
    params: state.params,
    attributes: state.attributes,
    previewLoading: state.previewLoading,
    productData: state.productData
  }),
  dispatch => ({
    updateParams: (...args) => dispatch(updateParams(...args)),
    setInfoNoticeWasShown: () => dispatch(setInfoNoticeWasShown())
  })
)(App));
